goog.provide("shadow.js.shim.module$src$svg$objects$magic_wand_svg");
goog.provide("module$shadow_js_shim_module$src$svg$objects$magic_wand_svg");
shadow.js.shim.module$src$svg$objects$magic_wand_svg = shadow.js.nativeProvides["src/svg/objects/magic-wand.svg"] = shadow$bridge("src/svg/objects/magic-wand.svg");
module$shadow_js_shim_module$src$svg$objects$magic_wand_svg.default = shadow.js.shim.module$src$svg$objects$magic_wand_svg;
